import { CommonModule } from '@angular/common'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, LOCALE_ID } from '@angular/core'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner'
import { ToastrModule } from 'ngx-toastr'

import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localePt, 'pt-BR');

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { StarterComponent } from "../starter/starter-master/starter.component"
import { StarterSidebarComponent } from "../starter/starter-sidebar/starter-sidebar.component"
import { StarterHeaderComponent } from "../starter/starter-header/starter-header.component"
import { StarterContentComponent } from "../starter/starter-content/starter-content.component"
import { StarterFooterComponent } from "../starter/starter-footer/starter-footer.component"
import { AppService } from './app.service'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { HomeComponent } from '../pages/home/home.component'
import { SharedModule } from '../shared/shared.module'
import { BreadcrumbComponent } from '../shared/breadcrumb/breadcrumb.component'
import { LoginService } from '../pages/login/login.service'
import { ModalService } from '../shared/modal/modal.service'
import { AuthGuard } from '../shared/security/auth.guard';
import { AuthService } from '../shared/security/auth.service';
import { StorageService } from '../shared/storage.service';
import { NotFoundComponent } from '../pages/not-found/not-found.component';
import { AuthInterceptor } from '../shared/security/auth.interceptor';
import { JwtTokenService } from '../shared/security/jwt.service';
import { InputSelectModule } from '../shared/input/input-select/input-select.module';
import { InputSelectService } from '../shared/input/input-select/input-select.service';
import { AddressModule } from '../shared/address/address.module';
import { ExcelService } from '../shared/excel.service';

@NgModule({
  declarations: [
    AppComponent,
    StarterComponent,
    StarterSidebarComponent,
    StarterHeaderComponent,
    StarterContentComponent,
    StarterFooterComponent,
    BreadcrumbComponent,
    HomeComponent,
    NotFoundComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    InputSelectModule,
    AddressModule,
    SharedModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      enableHtml: true,
      progressAnimation: "decreasing"
    }),
  ],
  exports: [
    InputSelectModule,
    AddressModule
  ],
  providers: [
    AppService,
    LoginService,
    ModalService,
    StorageService,
    AuthGuard,
    AuthService,
    JwtTokenService,
    InputSelectService,
    ExcelService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: "pt-BR"
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
